import React from 'react';

const StatusBadge = ({ status, className = "" }) => {
  const styles = {
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    completed: 'bg-green-100 text-green-800 border-green-200',
    default: 'bg-gray-100 text-gray-800 border-gray-200',
  };
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
      styles[status] || styles.default
    } ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
